<div class="container">
  <div class="row mt-3">
    <div class="col-12">
      <button
        *ngIf="strand"
        type="button"
        class="btn btn-link text-decoration-none strand-title"
        (click)="isCollapsed = !isCollapsed">
        {{ strand.title }}
        <span
          ><i class="bi bi-caret-{{ isCollapsed ? 'up' : 'down' }}-fill"></i
        ></span>
      </button>
    </div>
  </div>
  <div *ngIf="strand">
    <div class="row">
      <div class="col-12" *ngIf="strand && competency">
        <app-goal-slider
          [userId]="userId"
          [competencyId]="competency.id"
          [portfolioStrand]="strand"></app-goal-slider>
      </div>
    </div>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
      <div class="container p-0">
        <div class="row g-lg-2 g-xxl-3 row-cols-lg-4">
          <div class="col-lg mb-3">
            <app-portfolio-leveled-competency-strand-level
              [level]="1"
              [levelName]="level1name"
              [rubricId]="rubricId"
              [competency]="competency"
              [competencyTitle]="competencyTitle"
              [strand]="strand"
              [userId]="userId"
              [video]="level1video"
              [showOptions]="
                showOptions
              "></app-portfolio-leveled-competency-strand-level>
          </div>
          <div class="col-lg mb-3">
            <app-portfolio-leveled-competency-strand-level
              [level]="2"
              [levelName]="level2name"
              [rubricId]="rubricId"
              [competency]="competency"
              [competencyTitle]="competencyTitle"
              [strand]="strand"
              [userId]="userId"
              [video]="level2video"
              [showOptions]="
                showOptions
              "></app-portfolio-leveled-competency-strand-level>
          </div>
          <div class="col-lg mb-3">
            <app-portfolio-leveled-competency-strand-level
              [level]="3"
              [levelName]="level3name"
              [rubricId]="rubricId"
              [competency]="competency"
              [competencyTitle]="competencyTitle"
              [strand]="strand"
              [userId]="userId"
              [video]="level3video"
              [showOptions]="
                showOptions
              "></app-portfolio-leveled-competency-strand-level>
          </div>
          <div class="col-lg mb-3">
            <app-portfolio-leveled-competency-strand-level
              [level]="4"
              [levelName]="level4name"
              [rubricId]="rubricId"
              [competency]="competency"
              [competencyTitle]="competencyTitle"
              [strand]="strand"
              [userId]="userId"
              [video]="level4video"
              [showOptions]="
                showOptions
              "></app-portfolio-leveled-competency-strand-level>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
